type MarketHotkeyContext = {
  accessLevel: string
  selected: boolean
  marketId?: string
  createOpen: boolean
  subMarketkey: string
  targetTag?: string
}

/** Market-level R/B suspend hotkeys — skipped while create modal or submarket Short Keys is active. */
export function shouldIgnoreMarketSuspendHotkeys(ctx: MarketHotkeyContext): boolean {
  if (ctx.accessLevel !== 'admin' || !ctx.selected || !ctx.marketId) return true
  if (ctx.createOpen || ctx.subMarketkey) return true
  const tag = ctx.targetTag ?? ''
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  return false
}

export function resolveSubMarketShortKeyId(details: {
  marketId?: string | null
  _id?: string | null
}): string {
  return String(details.marketId || details._id || '')
}

export function shouldSubmitCreateMarketOnEnter(
  createOpen: boolean,
  key: string,
  saving = false,
): boolean {
  return createOpen && key === 'Enter' && !saving
}

/** Blocks a second OK / Enter while `/v1/sub-markets/save` is in flight. */
export function canStartCreateMarketSave(saving: boolean): boolean {
  return !saving
}
